// @ts-nocheck
import _ from 'lodash';
import {
  PREVIEW_ID,
  DOCUMENT_HEADER,
  EDITOR_TYPE,
  DOCUMENT_FOOTER,
} from '@src/utils/constants';

export function disableChildIframesPointerEvents(document: Document) {
  document
    .querySelectorAll('iframe')
    .forEach(frameElement => (frameElement.style.pointerEvents = 'none'));
}

export function enableChildIframesPointerEvents(document: Document) {
  document
    .querySelectorAll('iframe')
    .forEach(frameElement => (frameElement.style.pointerEvents = 'auto'));
}

export function getScrollOffset(
  previewFrame = document.getElementById(PREVIEW_ID),
) {
  if (previewFrame) {
    return (
      previewFrame.contentWindow.innerWidth -
      previewFrame.contentDocument.body.offsetWidth
    );
  } else {
    return 0;
  }
}

export function getViewerNewPageId(
  document: Document,
  cb: (pageId: string) => void,
) {
  const body = document.querySelector('body');
  const pageIdParentContainer = ['SITE_PAGES', 'SITE_PAGES_TRANSITION_GROUP'];
  const observer = new MutationObserver(mutations => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (
          _.indexOf(pageIdParentContainer, _.get(node, 'parentElement.id')) > -1
        ) {
          cb(node.id);
        }
      });
    });
  });
  if (body) {
    observer.observe(body, { childList: true, subtree: true });
  }
}

export const calcBreakpointWidth = ({ max, min, canvasSize }) => {
  if (_.isNumber(canvasSize)) {
    return canvasSize;
  }

  const val = min + (max - min) * 0.2;
  return Math.ceil(val / 10) * 10;
};

export const getDefaultBreakpoint = ({
  isSiteResponsive,
  currentBreakPoint,
  viewMode,
}: {
  isSiteResponsive: boolean;
  currentBreakPoint: any;
  viewMode: any;
}) => {
  return {
    id: isSiteResponsive ? currentBreakPoint.id : viewMode,
    maxWidth: currentBreakPoint.max,
    minWidth: currentBreakPoint.min,
  };
};

export const getCompParentSection = (
  element: Element | null | undefined,
  editorType: string,
) => {
  if (editorType === EDITOR_TYPE.EDITOR) {
    const siteHeader = element?.closest(`#${DOCUMENT_HEADER}`);
    return siteHeader ? 'HEADER' : 'MAIN';
  } else {
    const siteHeader = element?.closest('HEADER');
    return siteHeader ? 'HEADER' : 'MAIN';
  }
};

export const getCommentLocation = ({
  x,
  y,
  yIfScroll,
  previewEl,
  editorType,
  pageId,
  commentPageId,
}: {
  x: number;
  y: number;
  yIfScroll: number;
  previewEl: React.MutableRefObject<HTMLIFrameElement>;
  editorType: string;
  pageId: string;
  commentPageId: string;
}) => {
  let yPosition = y;
  const iframeContentWindow = previewEl.current.contentWindow;
  const comp = iframeContentWindow?.document.elementFromPoint(
    x,
    yIfScroll === y ? y : yIfScroll,
  );
  const isOnHeader = getCompParentSection(comp, editorType) === 'HEADER';
  if (!isOnHeader && commentPageId === DOCUMENT_HEADER) {
    if (editorType === EDITOR_TYPE.EDITOR) {
      const headerHeight =
        iframeContentWindow?.document?.getElementById(DOCUMENT_HEADER)
          ?.clientHeight || 0;
      yPosition -= headerHeight;
    }
    if (iframeContentWindow.pageYOffset > 0) {
      yPosition += iframeContentWindow.pageYOffset;
    }
  } else {
    yPosition = !isOnHeader ? y : yIfScroll;
  }
  return {
    xPosition: x,
    yPosition,
    compPageId: isOnHeader ? 'SITE_HEADER' : pageId,
  };
};

export const getVisitorId = (previewEl: any): string => {
  return previewEl?.current?.contentWindow?.viewerModel?.siteFeaturesConfigs
    ?.sessionManager?.sessionModel?.visitorId;
};

export type BoundsType = {
  left: number;
  right: number;
  top: number;
  bottom: number;
};

export const getHeaderHeight = (
  previewEl: React.MutableRefObject<HTMLIFrameElement>,
) => {
  return (
    previewEl?.current?.contentWindow?.document?.getElementById(DOCUMENT_HEADER)
      ?.clientHeight || 0
  );
};

export const getPageBounds = (
  previewEl: React.MutableRefObject<HTMLIFrameElement>,
): BoundsType => {
  const el = previewEl?.current?.contentWindow?.document?.getElementById(
    'SITE_CONTAINER',
  );
  const rect = el?.getBoundingClientRect();
  return {
    top: 0,
    bottom: _.toInteger(rect.height),
    left: 0,
    right: rect.width,
  };
};

export const updateSiteUrlWithWindowOrigin = (siteUrl: string) => {
  const url = new URL(siteUrl);
  const origin = window.location.origin;
  const updatedUrl = `${origin}${url.pathname}${url.search}${url.hash}`;
  return updatedUrl;
};
